import React, { useMemo } from "react";
import Chart from "react-apexcharts";

const PrimerChart2 = ({ rekapPrimer }) => {
    const convertToGroupedSeries = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
            return { categories: [], series: [] };
        }

        const izinKeys = new Set();
        data.forEach(item => {
            Object.keys(item).forEach(k => {
                if (k !== 'propinsi' && k !== 'total') {
                izinKeys.add(k);
            }
            });
        });

        const izinList = Array.from(izinKeys);

        const categories = data.map(item => item.propinsi.toUpperCase());

        const series = izinList.map(key => ({
            name: key,
            data: data.map(item => item[key] || 0),
        }));

        return { categories, series };
    };

    const { categories, series } = useMemo(
        () => convertToGroupedSeries(rekapPrimer),
        [rekapPrimer]
    );

    const chartOptions = {
        chart: {
            type: "bar",
            stacked: false,
            toolbar: { show: false },
            fontFamily: '"Inter", sans-serif',
        },
        plotOptions: {
            bar: {
                horizontal: true,
                columnWidth: "55%",
                barHeight: "85%",
                borderRadius: 4,
            },
        },
        xaxis: {
            categories,
            labels: {
                style: {
                    colors: "#004D40",
                    fontSize: "12px",
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: categories.map(() => "#004D40"),
                    fontSize: "12px",
                }
            }
        },
        tooltip: { enabled: true },
        legend: { position: "bottom" },
        dataLabels: { enabled: false },
        colors: ['#0071CE', '#F7941E', '#CF0F47', '#004D40', '#4BA38A', '#E6D8AE'],
    };

    return (
        <div>
            <Chart
                options={chartOptions}
                series={series}
                type="bar"
                height={categories.length * 70}
            />
        </div>
    );
};

export default PrimerChart2;
